import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import './Input.scss';

class Input extends React.Component {
  constructor(props) {
    super(props);
  }

  renderLabel(){
    const { props } = this;
    const{
      readonly,
      transformLabel,
      isValid,
      labelClassName,
      labelstyle,
      label
    } = props;
    return (
      <label
        className={classnames(
          `input__label ${readonly && transformLabel && 'active'}`,
          {
            valid: isValid,
            invalid: !isValid,
          },
          labelClassName
        )}
        style={labelstyle}
      >
        {label}
      </label>
    );
  }

  render(){
  const { props } = this;
  const {
    type,
    primary,
    secondary,
    tertiary,
    flat,
    outline,
    small,
    medium,
    large,
    full,
    centered,
    isValid,
    className,
    containerClassName,
    textClassName,
    readonly,
    style,
    placeholder,
    label,
    transformLabel,
    required,
    labelClassName,
    labelstyle,
    borderstyle,
    ...others
  } = props;

  let hasLabel = label && label.length > 0;

  return (
    <div
      className={classnames('material border-box', containerClassName, {
        'input__element--valid': isValid,
        'input__element--invalid': !isValid,
      })}
      style={borderstyle}
    >
      {type !== 'textarea' ? (
        <div className="flex flex-center flex-justify-center">
          <input
            readOnly={readonly}
            type={type}
            required={required}
            {...others}
            className={classnames(
              'input__element',
              {
                'input__element--primary': primary,
                'input__element--secondary': secondary,
                'input__element--flat': flat,
                'input__element--outline': outline,

                'input__element--small': small,
                'input__element--medium': medium,
                'input__element--large': large,
                'input__element--full': full,

                'input__element--valid': isValid,
                'input__element--invalid': !isValid,

                'input__element--centered': centered,
              },
              className
            )}
            placeholder={placeholder}
            style={style}
          />
          {hasLabel && this.renderLabel()}
        </div>
      ) : (
        <div className="flex flex-center flex-justify-center">
          <textarea
            {...others}
            type={type}
            readOnly={readonly}
            required={required}
            className={classnames(
              'input__element',
              {
                'input__element--primary': primary,
                'input__element--secondary': secondary,
                'input__element--flat': flat,
                'input__element--outline': outline,

                'input__element--small': small,
                'input__element--medium': medium,
                'input__element--large': large,
                'input__element--full': full,

                'input__element--valid': isValid,
                'input__element--invalid': !isValid,

                'input__element--centered': centered,
              },
              className
            )}
            placeholder={placeholder}
            style={style}
          />
          {hasLabel && this.renderLabel()}
        </div>
      )}
    </div>
  );
  }
}

Input.propTypes = {
  type: PropTypes.string,
  className: PropTypes.string,
  isValid: PropTypes.bool,
  primary: PropTypes.bool,
  secondary: PropTypes.bool,
  tertiary: PropTypes.bool,
  flat: PropTypes.bool,
  outline: PropTypes.bool,
  small: PropTypes.bool,
  medium: PropTypes.bool,
  large: PropTypes.bool,
  full: PropTypes.bool,
  centered: PropTypes.bool,
  containerClassName: PropTypes.string,
  textClassName: PropTypes.string,
  readonly: PropTypes.bool,
  style: PropTypes.object,
  placeholder: PropTypes.string,
  label: PropTypes.string,
  required: PropTypes.bool,
  labelClassName: PropTypes.string,
  labelstyle: PropTypes.object,
  borderstyle: PropTypes.object,
  transformLabel: PropTypes.any,
};

Input.defaultProps = {
  type: 'text',
  className: '',
  isValid: true,
  primary: false,
  secondary: false,
  tertiary: false,
  flat: false,
  outline: false,
  small: false,
  medium: false,
  large: false,
  full: false,
  centered: false,
  containerClassName: '',
  textClassName: '',
  readonly: false,
  style: {},
  placeholder: '',
  label: '',
  required: false,
  labelClassName: '',
  labelstyle: {},
  borderstyle: {},
  transformLabel: false,
};

export default Input;